import { BTIconSubs } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemShowSubsProps {
    fileId: number;
    isVisibleToSubs: boolean;
    onClick: () => Promise<void>;
}

const MenuItemShowSubs = ({
    fileId,
    isVisibleToSubs,
    onClick,
    ...antProps
}: IMenuItemShowSubsProps) => {
    const opacityPercent = isVisibleToSubs ? "40%" : "100%";
    const text = isVisibleToSubs ? "Hide from subs/vendors" : "Show subs/vendors";

    return (
        <BTMenu.Item
            {...antProps}
            key={`showSubs-menuitem-${fileId}`}
            testid={`showSubs-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconSubs style={{ opacity: opacityPercent }} /> {text}
        </BTMenu.Item>
    );
};

export default MenuItemShowSubs;
